<template>
  <section
    class="mothly-view-calc monthly-split-view table-monthly-view redo-header-events"
  >
    <div class="boxes-container">
      <div class="appointment-type">
        <div class="heading-appoitment emt-6">Event Info</div>
        <div class="input-wrapper">
          <input
            @input="setName($event.target.value)"
            :value="name.firstName"
            type="text"
            class="title"
            placeholder="Name"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("addNew", {
      name: "getName"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setName: "setFirstName"
    })
  }
};
</script>

<style scoped>
section {
  margin-top: 91px;
  margin-bottom: 45px;
}

input {
  border: none !important;
}

.input-wrapper {
  border-bottom: 35px solid #f7f7f7;
  outline: 1px solid #d0d0d0;
}
</style>
